import { $EnterABTest } from '@lemon8/web-app-shared/atom';
import { atom } from 'jotai';
import { get as _get } from 'es-toolkit/compat';

export const $LibraRestoreStreaming = atom<boolean>((get) => {
  const abTest = get($EnterABTest);

  return _get(abTest.parameters, 'seo_web.restore_streaming', false);
});

export const $LibraOptimizeSilentAwaken = atom<boolean>((get) => {
  const abTest = get($EnterABTest);

  return _get(abTest.parameters, 'seo_web.optimize_silent_awaken', false);
});

export const $LibraOptimizeScriptLoading = atom<boolean>((get) => {
  const abTest = get($EnterABTest);

  return _get(abTest.parameters, 'seo_web.optimize_script_loading', false);
});
